import getBasePath from '../functions/api-resource';

const basePath = getBasePath('job', 'configuracao');

const configuracaoActions = {
};

export default (resource) => resource(`${basePath}`, {}, configuracaoActions);
